<template>
  <div>
    {{ translate.result.default.received }}
    <br />
    {{ translate.result.default.instruction }}
  </div>
</template>

<script>
export default {
  name: 'default-result',
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
  },
};
</script>
